var _effectorFileName = "/builds/gmini/front-ui-kit/src/SelectMultiple/components/RenderOption/RenderOption.tsx";
import { useHover } from '@gmini/utils';
import { Checkbox } from '../../../Checkbox';
import { HighlightText } from '../../../HighlightText';
import { OptionWrapper } from '../OptionWrapper';
import { Label } from './RenderOption.styled';
import { selectCheckboxColors } from './selectCheckboxColors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-types
export const RenderOption = ({
  option,
  active,
  hover,
  onSelect,
  onMouseEnter,
  getOptionLabel,
  isHighlightEnabled,
  highlightingPattern,
  ...other
}) => {
  const {
    hover: mouseHover,
    onMouseLeave,
    onMouseOver
  } = useHover();
  return /*#__PURE__*/_jsxs(OptionWrapper, {
    onClick: event => {
      event.preventDefault();
      onSelect(option);
    },
    onMouseEnter: onMouseEnter,
    active: active,
    onMouseLeave: onMouseLeave,
    onMouseOver: onMouseOver,
    ...other,
    children: [/*#__PURE__*/_jsx(Checkbox, {
      hover: hover || mouseHover,
      checked: !!active,
      colors: selectCheckboxColors
    }), /*#__PURE__*/_jsx(Label, {
      children: !isHighlightEnabled ? getOptionLabel(option) : /*#__PURE__*/_jsx(HighlightText, {
        text: getOptionLabel(option),
        pattern: highlightingPattern || ''
      })
    })]
  });
};